export const LAUNCH_TIME = 1692373680 * 1000;
export const REVEAL_TIME = 1692632880 * 1000;
